<template lang="pug">
  .component-backoffice-policy-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false",)
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'GroupList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Group.vue'),
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.groups.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// GroupList.vue?46e3e1c0